import { t as a, c as p } from "./tw-merge-mgIb5Qhg.js";
import * as e from "react";
function l(...t) {
  return a(p(t));
}
function m(t, o, i) {
  const s = t, r = e.Children.map(
    s,
    (n) => e.isValidElement(n) && typeof n.type != "string" && n.type.displayName === o ? n : null
  );
  return e.Children.count(r) > 0 ? r : i;
}
export {
  l as c,
  m as g
};
